<template>
  <Card :title="title">
    <div class="flex flex-col w-full px-2 py-4 relative">
      <VueLoading :active.sync="loading" :is-full-page="false" />

      <!-- Chart Component Slot -->
      <slot name="graphic" />

      <!-- AI Analysis Section Slot -->
      <slot name="analysis" />
    </div>
  </Card>
</template>

<script>
import Card from '../../Card.vue'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'TimeSeries',
  components: {
    Card,
    VueLoading
  },
  props: {
    title: {
      type: String,
      default: 'Metrics Trends'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.dots-animation {
  display: inline-block;
}

.dot {
  opacity: 0;
  animation: dots 1.5s infinite;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.5s;
}

.dot:nth-child(3) {
  animation-delay: 1s;
}

@keyframes dots {
  0%, 20% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/AICards/TimeSeriesCard/TimeSeries.vue